import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { withRouter } from "react-router-dom";

import LinkButton from "../components/LinkButton";

import { ToastContainer, toast } from "react-toastify";
import { useHistory } from "react-router-dom";

import "react-toastify/dist/ReactToastify.css";

import { createBrowserHistory } from "history";

import { Redirect } from "react-router-dom";

import { useStateWithCallback } from "../utils/useStateWithCallback";

import * as Constants from "./Constants";

const baseUrl = Constants.URL();
const baseUrlHTMLBuilder = Constants.URLHTMLBuilder();

function UploadNewsletter() {
  useEffect(() => {
    checkIfIsAdmin();
  }, []);

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();

  const location = {
    pathname: "/Newsletters",
    state: { fromDashboard: true },
  };

  const history = createBrowserHistory();

  const [isLoggedIn, setIsLoggedIn] = React.useState(false);
  const [username, setUsername] = React.useState("");

  const [post, setPost] = React.useState(null);
  const [isValid, setIsValid] = useStateWithCallback(true);
  const [urlRedirect, seturlRedirect] = React.useState(null);
  const toastId = React.useRef(null);

  var checkIfIsAdmin = () => {
    var data;
    axios
      .get(`${baseUrl}Newsletters/all`, {
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      })
      .then((response) => {
        //setfileData(response.data);
      });
  };

  const fetchUsername = async () => {
    try {
      const { data } = await axios.get(`${baseUrl}Auth/username`);
      setUsername(data);

      if (data === false) {
        const location = {
          pathname: "/Login",
          state: { fromDashboard: true },
        };

        history.push(location);

        window.location.reload();
      }
      setIsLoggedIn(true);
      console.log(data);
    } catch (error) {
      setIsLoggedIn(false);
    }
  };

  React.useEffect(() => {
    fetchUsername();
  }, []);

  const onSubmit = function (data) {
    var newsletter = new FormData();
    newsletter.append("Id", 0);
    newsletter.append("Title", data.title);
    newsletter.append("CreatedDate", "");
    newsletter.append("UploadedFile", data.uploadFile[0]);
    newsletter.append("UploadHTMLFile", data.uploadHTMLFile[0]);
    var url = `${baseUrl}Newsletters/Create`;

    console.log(newsletter);
    console.log(data.uploadFile[0]);
    axios({
      method: "post",
      url: url,
      data: newsletter,
    })
      .then((response) => {
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.success("Submitted Successfully", {
            toastId: "success",
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            hideProgressBar: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });

          history.push(location);

          setTimeout(() => window.location.reload(), 3800);
        }
      })
      .catch((err) => {
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.error("Submission failed", {
            toastId: "failed",
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            hideProgressBar: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });
        }
      });
  };
  return (
    <div className="Card u-marginAuto u-marginBottom20">
      <div className="Card-content u-marginTop10">
        {isLoggedIn ? (
          <form onSubmit={handleSubmit(onSubmit)}>
            <input
              className="customInput"
              type="hidden"
              name="csrfmiddlewaretoken"
              value="0aiY5RDRupxjz3ITP49uNZ3YYfET3oeBn3RewbVyTP1JNRJIwc6YRdCACn9UbrQr"
            />
            <h2 className="Card-title u-marginBottom20">Upload a Newsletter</h2>
            <p>
              <label htmlFor="id_title">Title:</label>
              <input
                className="customInput"
                type="text"
                name="title"
                {...register("title", { required: true })}
                id="id_title"
              />
            </p>
            {errors.title && (
              <span className="required">Title is required</span>
            )}
            <p>
              <label htmlFor="id_uploadFile">Upload File:</label>
              <input
                className="customInput"
                type="file"
                name="uploadFile"
                {...register("uploadFile", { required: true })}
                id="id_uploadFile"
              />
            </p>
            {errors.uploadFile && (
              <span className="required">file is required</span>
            )}

            <p>
              <label>
                <a
                  className="marginRight"
                  href={baseUrlHTMLBuilder}
                  target="_blank"
                >
                  Click here
                </a>
                to generate HTML code then upload it.
              </label>
            </p>
            <p>
              <label htmlFor="id_uploadHTML">Upload HTML Template File:</label>
              <input
                className="customInput"
                type="file"
                name="uploadHTMLFile"
                {...register("uploadHTMLFile", { required: true })}
                id="id_uploadHTML"
              />
            </p>
            {errors.uploadHTMLFile && (
              <span className="required">file is required</span>
            )}

            <input type="Submit" className="Button"></input>
          </form>
        ) : (
          <div>You are not logged in</div>
        )}
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <ToastContainer />
    </div>
  );
}

export default withRouter(UploadNewsletter);
